import React, { Fragment, Suspense } from "react";
import Preloader from "../elements/Preloader";
const TrackingComponent = React.lazy(() => import("../components/TrackingComponent"));
const NavbarOne = React.lazy(() => import("../components/NavbarOne"));
const SearchPopup = React.lazy(() => import("../elements/SearchPopup"));
const FooterBottomOne = React.lazy(() =>
  import("../components/FooterBottomOne"));
const Tracking = () => {
  return (
    <>
      <Fragment>
        <Suspense fallback={<Preloader />}>
          {/* Search Popup */}
          <SearchPopup />

          {/* Navbar One */}
          <NavbarOne />

          {/* TrackingComponent */}
          <TrackingComponent/>

          {/* Footer Bottom One */}
          <FooterBottomOne />

        </Suspense>{" "}
      </Fragment>
    </>
  );
};

export default Tracking;
